import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { AppointmentData, AppointmentDateTime } from "../../PatientRecords/components";
import { getDateParts, getStatusTone } from "../../PatientRecords/utils";
import AwesomeIcon from "../../AwesomeIcon";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";
export var AppointmentItem = function AppointmentItem(appointment) {
  var dateParts = getDateParts(appointment.start_time);
  var joinedPractitionerArray = appointment.practitioners.flatMap(function (practitioner) {
    return !!practitioner.display ? practitioner.display : [];
  }).join(", ");
  var statusTone = getStatusTone(appointment.status);
  var reasonText = appointment.reason || appointment.description || "NA";
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("bg-white dark:bg-gray-800 rounded-2xl pt-5 pb-6 px-6 space-y-5 w-full", "border border-teal-500/[0.12] dark:border-teal-300/[0.16]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full gap-5 items-start"
  }, /*#__PURE__*/React.createElement(AppointmentDateTime, _extends({}, dateParts, {
    classes: statusTone.date
  })), /*#__PURE__*/React.createElement(AppointmentData, {
    appointment_type: appointment.appointment_type,
    practitioners: joinedPractitionerArray,
    service_category: appointment.service_category,
    location: appointment.location,
    reasonText: reasonText,
    service_type: appointment.service_type
  })), appointment.description && /*#__PURE__*/React.createElement("div", {
    className: "space-x-2 text-left"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPencil,
    className: "text-teal-400 w-[14px] h-[14px] inline mb-0.5"
  }), /*#__PURE__*/React.createElement("p", {
    className: "inline text-base text-gray-500 font-normal"
  }, appointment.description)), /*#__PURE__*/React.createElement("div", null));
};